export default "__VITE_ASSET__BffSsAEM__$_?no-inline__"